require.register("documenteditor/controllers/thesaurusCtrl", function(exports, require, module){
  $0
  
});

